/* ============================================================
   圖鑑：每一隻的敘述
   ============================================================

   使用者 2026-08-03 指定：右欄那一段從「家族的剪影規則」換成
   **每一隻自己的一段小敘述**，像一般 RPG 的圖鑑那樣。

   ## 三條寫作規則（後來的人要加新的時照著寫）

   1. **講它是什麼，不講怎麼打。** 怎麼打是「應對紀錄」那一段的事
      （`CODEX_TIP`）。兩段講同一件事的話，右欄就變成同一句話說兩次。
   2. **只寫畫面上看得到、或設定上成立的東西。** 這是圖鑑不是小說 ——
      寫「它的裝甲是斜的」可以驗證，寫「它來自三百年前的戰爭」不能。
   3. **一到兩句，句子短。** 這一欄的字級是 11px，長句在那個字級下沒人讀。

   深層（`deep`）那十二隻共用一個母題：**第三軸**。地表的東西有左右、
   有上下，深層的東西多一個方向 —— 所以它們歪、它們不對稱、它們不抬頭。 */

export var CODEX_LORE: Record<string, string> = {
  /* ---------- SPIKE 錐 ---------- */
  nadel: '量產型的最小單位。一根針、兩片翼、一顆核心 —— 拆到不能再拆，所以第一波永遠是它們。',
  lanze: '站定、抬起、放下。它不追你，它等你走進那條線。',
  geissel: '前端裂成五瓣才開始噴吐。名字是回收隊給的，他們說那聲音像鞭子抽在鐵板上。',
  fuhler: '它不攻擊，它指認。被指到的人身上會多一層看不見的標記。',
  spross: '深層長出來的東西沒有左右之分。它的刺歪向一邊，而每一隻歪的方向都不一樣。',
  faden: '一條看不見的線先貼上來，然後你才發現自己被拉住了。',

  /* ---------- WEDGE 楔 ---------- */
  keil: '整片斜甲就是它的臉。低、寬、貼地 —— 設計上只考慮一件事：把擋路的東西頂開。',
  pflug: '前緣翻起一道土。它走過的地方會留下一條乾淨的溝。',
  amboss: '它不跑，它跳。落地那一下比撞上來還重。',
  kriecher: '深層的東西學會了貼著地面移動。上面沒有天空可以看，也沒有必要抬頭。',
  laich: '一叢半透明的囊。踩破一顆，旁邊那幾顆會一起醒。',

  /* ---------- WALL 壁 ---------- */
  schild: '它的工作不是殺你，是不讓你過去。而它很擅長。',
  ramme: '一塊會助跑的牆。它沒有第二招，因為第一招通常就夠了。',
  luke: '半掩的門後面有東西在開火。門本身比後面那個難拆。',
  pforte: '深層的牆是可以穿過去的。問題是穿過去之後你在哪裡。',

  /* ---------- LADLE 勺 ---------- */
  morser: '它從不看你，只看你剛才站的地方。',
  haken: '拋出、勾住、收回。中間那一段你什麼也做不了。',
  bake: '它自己一發都不打。但它在的時候，其他每一隻都難打一階。',
  zunge: '深層的東西不需要嘴。這一條就是嘴的全部。',

  /* ---------- ORB 球 ---------- */
  dorn: '它靠近你是為了不見。剩下的事交給爆炸。',
  rolle: '一顆會轉的球。轉起來之後就沒有方向盤了。',
  auge: '浮在半空，緩慢地轉。被它看著的時候，別的東西會更準。',
  blase: '它撐開一層膜。膜裡面的東西暫時打不動。',
  klumpen: '不知道是幾隻黏在一起。它滾過來的時候你也不會想數。',
  iris: '深層的眼睛有很多層，而每一層轉的方向都不一樣。',

  /* ---------- BAR 桿 ---------- */
  spule: '充能的時候會亮。亮完之後那條線已經在你身上了。',
  sense: '近身、旋掃、退開。它只做這三件事，而且做得很快。',
  harfe: '一整排同時放。躲不掉單發，就躲整片的縫。',
  rippe: '深層的東西彼此相連。打斷一根，剩下的會更硬。',

  /* ---------- WING 翼 ---------- */
  krahe: '盤旋、對準、俯衝。它不打算落地。',
  falke: '比鴉快，也比鴉直。它撞上來的時候不會減速。',
  schwarm: '它從你頭上經過，然後地上開始開花。',
  horcher: '它飛得最高、離你最遠，通常也最晚被處理。而那正是它要的。',
  motte: '深層的飛行沒有航線。它不是在閃你，它本來就是這樣飛的。',

  /* ---------- RING 環 ---------- */
  nest: '一個會開口的環。開一次，多三隻。',
  reifen: '它滾過來，然後套住你。',
  kranz: '整圈同時開火。沒有安全的角度，只有安全的距離。',
  wirbel: '站在它旁邊的時候，你會發現自己一直在往裡面走。',
  maul: '深層的環會咬合。那是環，也是嘴。',
  leier: '弦繃在環上。撥一下，一整排射線就出去了。',

  /* ---------- BOSS ---------- */
  walze: '四足頂起一整塊方形量體，前面掛著碾壓輪。它不需要瞄準 —— 它只要往前。',
  zenit: '浮在你打不到的高度，兩具砲莢輪流開口。打亮的地方才是它的重量。',
  kathedrale: '一座會走的建築。你躲的每一根柱子都是它身上的零件。',
  sichel: '巨大的單刃繞著自己轉。它不追擊，它清場。',
  mutter: '環形托架抱著一顆巨球。球裡面還有東西沒出來。',
  turm: '立著的時候是攻城兵器。倒下之後才真正開始。',
  schlange: '十三節，每一節都能自己轉。頭在哪裡並不重要。',
  zwilling: '兩具共用一副骨架。殺掉一邊，另一邊會變快。',
  spalter: '它被打的時候不是變弱，是變多。',
  gerippe: '肋條圍成的空籠。開合之間那一瞬是它唯一的破綻。',
  krone: '三層環各自轉。看起來像儀器，動起來像武器。',
  spinne: '八條腿撐起一顆低垂的核心。它不跑，它跨過來。',
  flut: '不是一隻，是很多塊。它們在你面前聚成一個形狀。',
  waage: '左右不對稱，而且它知道。重的那一邊永遠先動。',
  kokon: '外殼是給你剝的。裡面那個才是它。',
  brucke: '兩根柱子扛著一段跨距。走到它下面之前，先想想跨距會不會落下來。',
  augenwald: '十二隻眼睛長在同一叢桿子上，各看各的。',
  namenlos: '五重對稱。地表的東西不會長成這樣，所以回收隊沒有給它名字。',
  hohlraum: '它沒有骨架。撐著它的是那個洞本身。',
  armilla: '環套著環，而它們的軸線互不相交。你不會想盯著看太久。',
  wirt: '身上掛著的不是裝甲，是別的東西。而它們還活著。',
  tiefe: '它不完整。缺的那一部分不在別的地方 —— 它就是那個缺口。',
  stille: '它從頭到尾沒有動過。而你身上的傷是真的。',

  /* ---------- 最終 ---------- */
  kaiser: '最後一台成型的機甲。九十七個部件，每一個都還在運作。',
  chimare: '八個家族的特徵長在同一具身體上。它不屬於任何一族 —— 它是全部。',
  requiem: '用你的同型機殘骸堆起來的船。你認得出那些零件。',
  weltachse: '四十八公尺。畫面框不下它，所以你只能一段一段地看。',
  nichts: '最後只剩下一個空洞。而空洞也會反擊。'
};

export var LORE_FALLBACK = '（尚未建立敘述）';
export function codexLore(id) { return CODEX_LORE[id] || LORE_FALLBACK; }
